import * as THREE from 'three';

import { Pass } from 'postprocessing';

export class BilateralFilterPass extends Pass {
  private bilateralMaterial: THREE.ShaderMaterial;

  private filterOutputTarget: THREE.WebGLRenderTarget | undefined;

  private depthTexture: THREE.DepthTexture | null;

  constructor(
    bilateralMaterial: THREE.ShaderMaterial,
    filterOutputTarget: THREE.WebGLRenderTarget | undefined
  ) {
    super('BilateralFilterPass');

    this.bilateralMaterial = bilateralMaterial;
    this.fullscreenMaterial = this.bilateralMaterial;
    this.needsDepthTexture = true;
    this.depthTexture = null;
    this.filterOutputTarget = filterOutputTarget;
  }

  render(
    renderer: THREE.WebGLRenderer,
    inputBuffer: THREE.WebGLRenderTarget,
    outputBuffer: THREE.WebGLRenderTarget
    // _deltaTime: number,
    // _stencilTest: boolean
  ) {
    this.bilateralMaterial.uniforms.ColorTexture.value = inputBuffer.texture;
    this.bilateralMaterial.uniforms.DepthTexture.value = this.depthTexture;
    this.bilateralMaterial.uniformsNeedUpdate = true;

    // this.bilateralMaterial.needsUpdate = true;

    // renderer.setRenderTarget(this.renderToScreen ? null : outputBuffer);
    // renderer.render(this.scene, this.camera);
    renderer.setRenderTarget(this.filterOutputTarget ?? outputBuffer);
    renderer.render(this.scene, this.camera);
  }

  setDepthTexture(
    depthTexture: THREE.DepthTexture
    // depthPacking: THREE.DepthPackingStrategies | undefined
  ) {
    this.depthTexture = depthTexture;
    this.bilateralMaterial.uniforms.DepthTexture.value = this.depthTexture;
    this.bilateralMaterial.uniformsNeedUpdate = true;
  }

  // initialize(
  //   _renderer: THREE.WebGLRenderer,
  //   _alpha: boolean,
  //   frameBufferType: THREE.TextureDataType
  // ) {
  //   if (frameBufferType !== undefined && frameBufferType !== THREE.UnsignedByteType) {
  //     this.bilateralMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = '1';
  //     this.bilateralMaterial.needsUpdate = true;
  //   }
  // }
}
